import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import MoleculeTextareaField from '@s-ui/react-molecule-textarea-field'

import {MAX_REPLY_LENGTH, NO_OP, REPLY_FORM_ID} from '../config.js'

const CardRatingReplyForm = ({
  helpText,
  id,
  onChange = NO_OP,
  onReplySubmit = NO_OP,
  onReplyCancel = NO_OP,
  placeholder,
  text,
  replyCancelButtonLabel,
  replySubmitButtonLabel,
  isReplySubmitDisabled
}) => {
  return (
    <div className="mt-CardRating-replyForm">
      <MoleculeTextareaField
        id={`${REPLY_FORM_ID}-${id}`}
        maxChars={MAX_REPLY_LENGTH}
        onChange={onChange}
        placeholder={placeholder}
        tabIndex="0"
        textCharacters={helpText}
        value={text}
      />
      <div className="mt-CardRating-replyForm-buttons">
        <AtomButton
          aria-label={replyCancelButtonLabel}
          design={atomButtonDesigns.OUTLINE}
          onClick={onReplyCancel}
          shape={atomButtonShapes.CIRCULAR}
          isFitted
          size="medium"
        >
          {replyCancelButtonLabel}
        </AtomButton>

        <AtomButton
          aria-label={replySubmitButtonLabel}
          onClick={onReplySubmit}
          design={atomButtonDesigns.SOLID}
          isFitted
          shape={atomButtonShapes.CIRCULAR}
          disabled={isReplySubmitDisabled}
          size="medium"
        >
          {replySubmitButtonLabel}
        </AtomButton>
      </div>
    </div>
  )
}

CardRatingReplyForm.displayName = 'CardRatingReplyForm'

CardRatingReplyForm.propTypes = {
  helpText: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  onReplySubmit: PropTypes.func,
  onReplyCancel: PropTypes.func,
  placeholder: PropTypes.string,
  replyCancelButtonLabel: PropTypes.string,
  replySubmitButtonLabel: PropTypes.string,
  text: PropTypes.string,
  isReplySubmitDisabled: PropTypes.bool
}

export default CardRatingReplyForm
